import { useEffect, useState } from "react";
import { getCurrentUserRoles } from "../utils/authorization";

/** Roles of the signed-in user (empty until loaded), for role-based tabs in hub pages. */
export function useUserRoles(): string[] {
  const [roles, setRoles] = useState<string[]>([]);
  useEffect(() => {
    let cancelled = false;
    void getCurrentUserRoles().then((r) => {
      if (!cancelled) setRoles(r);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return roles;
}
